// Copyright 2026. WebPros International GmbH. All rights reserved.
import styled from 'styled-components';

export const TargetCRSelectionGroupLabel = styled.div`
    color: #555;
    font-weight: bold;
`;

export const TargetCRSelectionOptionLabel = styled.div<{disabled?: boolean}>`
    ${props => props.disabled ? ' color: #777':  ''}
`;

export const AvailableResourcesContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;

export const IncompatibleReason = styled.div`
    font-size: 12px;
    opacity: .7;
    color: red;
`;

export const SectionTitle = styled.div`
    font-size: 14px;
    display: flex;
    align-items: center;
    span {
        margin-right: 5px;
    }
`;

export const FormFooter = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const AvailableResourceContainer =  styled.div<{muted?: boolean}>`
    text-align: center;
    opacity: ${props => props.muted ? '0.7' : '1'};
`;

export const AvailableResourceCircle = styled.div<{width: number; height: number}>`
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    margin: 10px;
    width: ${props => props.width}px;
    height: ${props => props.height}px;
`;

export const AvailableResourceCircleSvg = styled.svg`
    display: block;
`;

export const CircleBackground = styled.circle`
    fill: #f5f5f5; /* Light gray background */
    stroke: #d3d3d3; /* Light gray border */
    stroke-width: 2; /* Thicker border */
    cx: 50;
    cy: 50;
    r: 47;
`;
export const CircleProgressBar = styled.circle`
    fill: none;
    stroke: #4a5e4a; /* Dark green for progress */
    stroke-width: 2; /* Match border thickness */
    stroke-linecap: round; /* Smooth ends */
    transform: rotate(-90deg); /* Start from top */
    transform-origin: center;
    cx: 50;
    cy: 50;
    r: 47;
`;

export const AvailableResourceCircleContent = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: Arial, sans-serif;
    color: #333;
    text-align: center;
    box-sizing: border-box;
    div {
        font-weight: 600;
    }
`;
